import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';

export default function TermsPage() {
  useSeo({
    title: 'Terms of Use',
    description: 'Review TheScandal terms for responsible usage, moderation policy, and platform limitations.',
    path: '/terms',
    keywords: [
      'terms of use',
      'community guidelines',
      'moderation rules',
      'content policy',
      'platform terms',
    ],
  });

  return (
    <section className="legal-page">
      <h1>Terms of Use</h1>
      <p className="legal-updated">Last updated: March 10, 2026</p>

      <h2>Acceptance</h2>
      <p>By using this platform, you agree to these terms and applicable laws.</p>

      <h2>Allowed Use</h2>
      <ul>
        <li>Share incidents and discussions responsibly.</li>
        <li>Do not post illegal content, targeted harassment, or explicit threats.</li>
        <li>Do not impersonate officials or spread harmful disinformation intentionally.</li>
      </ul>

      <h2>Community Guidelines</h2>
      <p>To keep TheScandal safe and useful for everyone, users must follow these guidelines:</p>
      <ul>
        <li>Share information responsibly. Do not spread false accusations or misinformation.</li>
        <li>Do not post pornography, explicit content, or unrelated material.</li>
        <li>Do not post threats, harassment, or hate speech.</li>
        <li>Do not expose private personal details such as home addresses, ID numbers, or phone numbers unless it is necessary for public safety and legally appropriate.</li>
        <li>Respect victims and avoid posting graphic or disturbing content.</li>
      </ul>
      <p>Administrators may remove any post or comment that violates these guidelines.</p>

      <h2>Legal Disclaimer</h2>
      <p>
        Our goal is to create a space where people can share real-world updates, raise awareness about important issues, and help communities stay connected and informed.
      </p>

      <h2>Moderation</h2>
      <p>Admins may flag or remove posts/comments that violate policy.</p>

      <h2>No Warranty</h2>
      <p>The service is provided "as is" without guarantees of uptime, accuracy, or fitness for a specific purpose.</p>

      <h2>Limitation</h2>
      <p>To the extent permitted by law, the platform is not liable for user-generated content outcomes.</p>

      <p className="legal-back"><Link to="/">Back to Feed</Link></p>
    </section>
  );
}
